<div fxLayout="row" fxLayoutAlign="end center">
  @for (action of primaryActions; track action) {
    <metadata-action [action]="action" [model]="model" [formData]="formData"
      (actionCallback)="callback($event)" primary="true" enable-shortcut="true" [dense]="compactMode"
      [ngClass]="{'dense-chip': isChip(action) && compactMode}" [expansionPanelAction]="expansionPanelAction ? 'true' : undefined" >
    </metadata-action>
  }

  @if (hasOverflowActions) {
    <forge-menu [options]="menuOptions" placement="bottom" [attr.forge-ignore]="expansionPanelAction ? 'true' : undefined"
      (forge-menu-select)="menuItemSelected($event)" style="pointer-events: auto;" [dense]="compactMode" (forge-menu-open)="menuOpened($event)">
      <forge-icon-button telemetry="Menu-Actions" aria-label="actions menu" [dense]="compactMode">
        <forge-icon name="more_vert"></forge-icon>
      </forge-icon-button>
    </forge-menu>
  }
</div>